module.exports = __webpack_public_path__ + "static/media/aika.de76b9f3.png";